module.exports = __webpack_public_path__ + "static/b-a-2-before-ac426b38e287b6209ef1907dcb894723.jpg";